<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="schedule_list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            v-wechat-title="title"
            :tableHeight="tableHeight"
            :dialogWidth="dialogWidth"
            :addButton="{ permission: 'schedule_dic:create' }"
            :updateButton="{ permission: 'schedule_dic:edit' }"
            :deleteButton="{ enabled: true, permission: 'schedule_dic:delete' }"
            @beforeOpenAddView="beforeOpenAddView"
        >
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="refreshList()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
            </template>
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `DicSchedule`,
    props: {},
    data() {
        return {
            title: `排班管理`,
            dialogWidth: `60%`,
            currentPage: 1,
            pageSize: 50,
            currentid: 0,
            total: 0,
            defaultWardType: 2,
            defaultfilepath: ``,
            fileUploadConfig: this.$root.FileUploadConfig,
            users: [],
            url: {
                baseURL: `/api/AcisSystem/DicSchedule`,
                get: () => {
                    this.defaultfilepath = ``
                    return new Promise(resolve => {
                        let req = this.myaxios.get(`/api/AcisSystem/DicSchedule/Get`)
                        req.then(data => {
                            if (data && data.length > 0) {
                                for (let j = 0; j < data.length; j++) {
                                    if (data[j].schedule_wards) {
                                        for (let i = 0; i < data[j].schedule_wards.length; i++) {
                                            data[j].schedule_wards[i].dic_ward_id = data[j].schedule_wards[i].enum_ward_type == 1 ? `ow_${data[j].schedule_wards[i].dic_ward_id}` : `rw_${data[j].schedule_wards[i].dic_ward_id}`
                                        }
                                    }
                                }
                            }
                            resolve(data)
                        })
                    })
                },
                getOne: row => {
                    this.defaultWardType = row.type
                    this.currentid = row.id
                    let newData = { ...row }
                    if (row.enum_worker_duty_ids) {
                        newData.enum_worker_duty_ids = row.enum_worker_duty_ids.split(`,`).map(item => parseInt(item))
                    }
                    if (row.schedule_wards) {
                        row.schedule_wards = _.orderBy(row.schedule_wards, `dic_ward_name`)
                        let arr = []
                        let customwards = []
                        for (let i = 0; i < row.schedule_wards.length; i++) {
                            let item = row.schedule_wards[i]
                            if (item.dic_room_id > 0) {
                                let str = item.dic_ward_id + `_` + item.dic_room_id
                                arr.push(str)
                            } else {
                                customwards.push(item)
                            }
                        }
                        newData = { ...newData, schedule_wards: arr, custom_wards: customwards }
                    }
                    // logo生成
                    let r2 = _.cloneDeep(newData)
                    if (r2.logo && r2.logo != ``) {
                        newData.logoobj = [{
                            name: r2.logo,
                            url: `${this.$root.BASE_URL}api/AcisSystem/DicSchedule/GetPictureFile/${row.id}?fileName=${r2.logo}`,
                            uid: `p${row.id}`
                        }]
                    }
                    console.log(`newdata`, newData)
                    return Promise.resolve(newData)
                },
                post: data => {
                    // 修改前效验
                    return this.checkValidate(true, data)
                },
                put: data => {
                    // 修改前效验
                    return this.checkValidate(false, data)
                }
            },
            buttons: [],
            shifts: []
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadUsers()
        this.loadShifts()
    },
    computed: {
        ...mapGetters([`sysuser/workers`, `permissions`, `section_auth`, `operation_room_auth`, `sys_enums`, `screenHeight`, `ward_auth`, `currentUser`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        _shifts() {
            return this.shifts && this.shifts.map(i => {
                return { value: i.id, label: i.name }
            })
        },
        columnList() {
            let me = this
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `80`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    readonly: false,
                    sortable: true,
                    isDisplayOrder: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }, { min: 0, max: 50, message: `长度50个字符以内`, trigger: `blur` }],
                    colspan: 12
                },
                {
                    type: `bool`,
                    prop: `status_b`,
                    label: `状态`,
                    width: `70`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    default: true,
                    options: `is_used`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    colspan: 4
                },
                {
                    type: `select`,
                    prop: `type`,
                    label: `类型`,
                    width: `70`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: [
                        { label: `手术区护士排班`, value: 1 },
                        { label: `医护排班`, value: 2 }
                    ],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    colspan: 8,
                    change: (that, { row }) => {
                        me.defaultWardType = row.type
                    },
                    default: 2
                },
                {
                    type: `string`,
                    prop: `schedule_title`,
                    label: `标题`,
                    width: `180`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ min: 0, max: 100, message: `长度100个字符以内`, trigger: `blur` }],
                    colspan: 12
                },
                {
                    type: `remotemultiselect`,
                    prop: `userarrs`,
                    label: `排班人`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    showCount: 300,
                    collapseTags: false,
                    options: `/api/AcisSystem/SysUser/SearchForKey`,
                    colspan: 12
                },
                {
                    type: `multiselect`,
                    prop: `enum_worker_duty_ids`,
                    label: `角色`,
                    width: `180`,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    collapseTags: false,
                    options: this.sys_enums.WorkerDuty || [],
                    colspan: 12
                },
                {
                    type: `integer`,
                    prop: `role_row_count`,
                    label: `角色显示行/列`,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    default: 2,
                    colspan: 4,
                    width: `100`
                },
                {
                    type: `integer`,
                    prop: `role_column_count`,
                    label: ``,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    default: 2,
                    colspan: 4,
                    width: `100`
                },
                {
                    type: `select`,
                    prop: `dic_ward_id`,
                    label: `所属区域`,
                    width: `180`,
                    isListable: false,
                    isExpand: false,
                    isCreatable: me.defaultWardType == 2,
                    isEditable: me.defaultWardType == 2,
                    searchable: true,
                    sortable: true,
                    options: this[`ward_auth`],
                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `dic_section_id`,
                    label: `科室`,
                    width: `180`,
                    isListable: true,
                    isEditable: me.defaultWardType == 2,
                    isCreatable: me.defaultWardType == 2,
                    searchable: true,
                    options: this[`section_auth`],
                    colspan: 12
                },
                // {
                //     type: `selecttree`,
                //     prop: `schedule_wards`,
                //     label: `所属区域`,
                //     width: `180`,
                //     // isListable: true,
                //     isEditable: me.defaultWardType == 1,
                //     isCreatable: me.defaultWardType == 1,
                //     searchable: false,
                //     collapseTags: false,
                //     options: this.loadnoticelocation,
                //     colspan: 24
                // },
                // {
                //     type: `multiselect`,
                //     prop: `userids`,
                //     label: `排班人`,
                //     isListable: true,
                //     isEditable: true,
                //     isCreatable: true,
                //     showCount: 300,
                //     collapseTags: false,
                //     options: this.users,
                //     colspan: 24
                // },
                {
                    type: `textarea`,
                    prop: `notice`,
                    label: `通告`,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    config: {
                        minRows: 2
                    },
                    validate: [{ min: 0, max: 100, message: `长度100个字符以内`, trigger: `blur` }],
                    colspan: 24
                },
                {
                    type: `textarea`,
                    prop: `remark`,
                    label: `备注`,
                    isEditable: me.defaultWardType == 2,
                    isCreatable: me.defaultWardType == 2,
                    validate: [{ min: 0, max: 250, message: `长度250个字符以内`, trigger: `blur` }],
                    config: {
                        minRows: 2
                    },
                    colspan: 24
                },
                {
                    type: `selecttree`,
                    prop: `schedule_wards`,
                    label: `标准手术间`,
                    width: `180`,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    searchable: false,
                    collapseTags: false,
                    options: this.loadnoticelocation,
                    colspan: 24
                },
                {
                    type: `table`,
                    prop: `custom_wards`,
                    label: `自定义手术间`,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `编号`,
                            width: `80`,
                            isKey: true,
                            isListable: false
                        },
                        {
                            type: `select`,
                            prop: `dic_ward_id`,
                            label: `所属区域`,
                            isListable: true,
                            isExpand: false,
                            searchable: true,
                            sortable: true,
                            readonly: false,
                            options: this[`ward_auth`]
                        },
                        {
                            type: `integer`,
                            prop: `dic_room_id`,
                            label: ``,
                            readonly: true,
                            isListable: false,
                            default: 0
                        },
                        {
                            type: `string`,
                            label: `手术间`,
                            prop: `dic_room_name`,
                            isListable: true,
                            readonly: false
                        },
                        {
                            type: `integer`,
                            prop: `row_counts`,
                            label: `角色显示行`,
                            readonly: false,
                            isListable: true,
                            default: 2
                        },
                        {
                            type: `integer`,
                            prop: `column_counts`,
                            label: `角色显示列`,
                            readonly: false,
                            isListable: true,
                            default: 2
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        height: this.screenHeight - 500
                    }
                },
                {
                    type: `bool`,
                    prop: `is_shift_multward`,
                    label: `班次跨区域`,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    colspan: 24
                },
                {
                    type: `table`,
                    prop: `schedule_shifts`,
                    label: `班次`,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `编号`,
                            width: `80`,
                            isKey: true,
                            isListable: false
                        },
                        {
                            type: `select`,
                            prop: `dic_shift_id`,
                            label: `选择班次`,
                            isListable: true,
                            isExpand: false,
                            searchable: true,
                            sortable: true,
                            readonly: false,
                            options: this._shifts
                        },
                        {
                            type: `integer`,
                            prop: `row_counts`,
                            label: `行`,
                            width: `120`,
                            readonly: false,
                            isListable: true,
                            default: 2
                        },
                        {
                            type: `integer`,
                            prop: `column_counts`,
                            label: `列`,
                            width: `120`,
                            readonly: false,
                            isListable: true,
                            default: 2
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        height: this.screenHeight - 500
                    }
                },
                {
                    type: `select`,
                    prop: `default_view`,
                    label: `视图`,
                    width: `100`,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    colspan: 8,
                    options: [
                        { label: `周视图`, value: 1 },
                        { label: `日试图`, value: 2 }
                    ],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `integer`,
                    prop: `title_font_size`,
                    label: `字体大小`,
                    width: `100`,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    colspan: 6
                },
                {
                    type: `colorpicker`,
                    prop: `title_color`,
                    label: `颜色`,
                    width: `180`,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    colspan: 6
                },
                {
                    type: `upload`,
                    prop: `logoobj`,
                    label: `logo`,
                    isEditable: me.defaultWardType == 1,
                    isCreatable: me.defaultWardType == 1,
                    colspan: 24,
                    options: (that, { row }) => {
                        // 上传照片
                        return `${this.$root.BASE_URL}api/AcisSystem/DicSchedule/PostFiles/${row.origion && row.origion.id || 0}`
                    },
                    config: {
                        multiple: false,
                        multipleLimit: 1,
                        accept: `image/jpeg`,
                        onExceed: (files, fileList) => {
                            this.$message.warning(`超过最大文件数`)
                        },
                        onFileSuccess: (response, file, fileList) => {
                            // 上传成功将图片路径放到defaultfilepath
                            this.defaultfilepath = response.data
                        },
                        removeFile: (file, fileList) => {
                            // 删除照片
                            let req = this.myaxios.delete(`/api/AcisSystem/DicSchedule/DeleteFile/${this.currentid}?fileName=${file.response && file.response.data}`)
                            req.then(data => { })
                        },
                        beforeUpload: file => {
                            let fileconfig = JSON.parse(this.fileUploadConfig)
                            let extensions = fileconfig && fileconfig.ImageExtensions ? fileconfig.ImageExtensions.split(`,`) : []
                            let maxSize = Number(fileconfig.MaxSize) * 1024 * 1024

                            if (!(file.size < maxSize)) {
                                this.$message.error(`上传文件大小不能超过[${fileconfig.MaxSize}]MB!`)
                                return false
                            }
                            let filetype = file.name
                                .split(`.`)
                                .slice(-1)[0]
                                .toLowerCase()
                            if (!_.includes(extensions, `.` + filetype)) {
                                this.$message.error(`上传文件只能是[${fileconfig.ImageExtensions}]格式!`)
                                return false
                            }
                        }
                    }
                }
            ]
        },
        loadnoticelocation() {
            let options = []
            this.ward_auth.map(ward => {
                let wardoption = {
                    label: `${ward.label}`,
                    value: `${ward.value}`,
                    jianpin: `${ward.jianpin}`,
                    code: `${ward.code}`
                }
                let children = []
                if (ward.operation_room && ward.operation_room.length > 0) {
                    ward.operation_room.map(room => {
                        children.push({
                            label: room.label,
                            value: `${ward.value}_${room.value}`,
                            jianpin: room.jianpin,
                            code: room.jianpin,
                            parent_value: `${ward.value}`
                        })
                    })
                } else if (ward.recovery_bed && ward.recovery_bed.length > 0) {
                    ward.recovery_bed.map(room => {
                        children.push({
                            label: room.label,
                            value: `${ward.value}_${room.value}`,
                            jianpin: room.jianpin,
                            code: room.jianpin,
                            parent_value: `${ward.value}`
                        })
                    })
                }
                if (children.length > 0) {
                    wardoption.children = children
                }
                options.push(wardoption)
            })
            console.log(`optionsoptions-----------`)
            console.log(options)
            return options
        }
    },
    mounted() {},
    methods: {
        checkValidate(isAdd, data) {
            let that = this
            return new Promise((resolve, reject) => {
                let newData = _.cloneDeep(data)
                if (data.enum_worker_duty_ids) {
                    newData.enum_worker_duty_ids = data.enum_worker_duty_ids.join(`,`)
                }
                if (data.userarrs && Array.isArray(data.userarrs)) {
                    newData.userids = data.userarrs.map(item => item.value)
                }
                // 301 排班大屏
                if (newData.type == 1 && (!newData.schedule_wards || newData.schedule_wards.length == 0) && (!newData.custom_wards || newData.custom_wards.length == 0)) {
                    this.$message.error(`请选择手术间`)
                    return reject(null)
                }
                if (newData.schedule_wards) {
                    let arrward = []
                    for (let i = 0; i < newData.schedule_wards.length; i++) {
                        let item = newData.schedule_wards[i]
                        let itemarr = item.split(`_`)
                        let ward = {
                            dic_schedule_id: newData.id,
                            enum_ward_type: itemarr[0] === `ow` ? 1 : 2,
                            dic_ward_id: parseInt(itemarr[1]),
                            dic_ward_name: ``,
                            dic_room_id: parseInt(itemarr[2]),
                            dic_room_name: this.getOperationNameById(itemarr[2]),
                            row_counts: newData.role_row_count,
                            column_counts: newData.role_column_count
                        }
                        arrward.push(ward)
                    }
                    newData.schedule_wards = arrward
                }

                if (newData.custom_wards) {
                    for (let i = 0; i < newData.custom_wards.length; i++) {
                        let item = newData.custom_wards[i].dic_ward_id
                        let itemarr = item.split(`_`)
                        newData.custom_wards[i].enum_ward_type = itemarr[0] === `ow` ? 1 : 2
                        newData.custom_wards[i].dic_ward_id = parseInt(itemarr[1])
                    }
                }
                if (newData.type == 1) {
                    newData.schedule_wards = newData.schedule_wards.concat(newData.custom_wards)
                }
                return that.addEdit(isAdd, newData).then(data => {
                    resolve(data)
                })
            })
        },
        addEdit(isadd, newData) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios[isadd ? `post` : `put`](`/api/AcisSystem/DicSchedule/${isadd ? `Post` : `Put`}`, newData)
                req.then(data => {
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        getOperationNameById(id) {
            if (!id) return ``
            let item = _.find(this.operation_room_auth, x => x.value == parseInt(id))
            if (item) { return item.label || `` }
            return ``
        },
        loadShifts() {
            let req = this.myaxios.get(`/api/AcisSystem/DicShift/Get`)
            req.then(data => {
                this.shifts = data.filter(i => i.status == 1)
            })
        },
        loadUsers() {
            let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
            req.then(data => {
                this.users = _.map(data, d => {
                    return {
                        value: d.id,
                        label: d.dic_worker_name || `--`,
                        disabled: d.is_deleted,
                        code: `${d.dic_worker_worker_duty || `--`}|${d.dic_worker_surgery_scale || `--`}|${d.dic_worker_section_name || `--`}`
                    }
                })
            }).catch(e => {
                console.log(e)
            })
        },
        beforeOpenAddView() {
            this.defaultWardType = 2
        },
        refreshList() {
            this.$refs[`schedule_list`].ReloadListData()
        }
    }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Dictionary/Schedule/DicSchedule.vue